//@flow
import React from 'react';
import { Box, Text } from '@locus-taxy/neo-ui';
import type { TFunction } from 'react-i18next';

import moment from 'moment-timezone';
import TooltipContent, {
    TooltipHeader,
    TooltipBody,
    TooltipItem,
    TooltipSection
} from 'common/components/common/TooltipContent';
import { type FpPjPlan } from 'common/models/internal/FpPjPlan';

type FpPlanDetailsTooltipProps = {
    plan: FpPjPlan,
    t: TFunction
};

class FpPlanDetailsTooltip extends React.PureComponent<FpPlanDetailsTooltipProps> {
    render() {
        const { plan, t } = this.props;
        return (
            <TooltipContent minWidth={240}>
                <TooltipHeader
                    value={
                        <Box mb={1} mt={2}>
                            <Text fontSize={2} fontWeight={600}>
                                {t('fpPlanView.planInformation')}
                            </Text>
                        </Box>
                    }
                />
                <TooltipBody>
                    <TooltipSection>
                        <TooltipItem>
                            <TooltipItem.Title
                                value={
                                    <Text fontSize={0}>
                                        {t('fpPlanView.planId')}
                                    </Text>
                                }
                            />
                            <TooltipItem.Value
                                value={
                                    <Text fontSize={1} fontWeight="medium">
                                        {plan.id}
                                    </Text>
                                }
                            />
                        </TooltipItem>
                    </TooltipSection>
                    <TooltipSection>
                        <TooltipItem>
                            <TooltipItem.Title
                                value={
                                    <Text fontSize={0}>
                                        {t('fpPlanView.creationDate')}
                                    </Text>
                                }
                            />
                            <TooltipItem.Value
                                value={
                                    <Text fontSize={1} fontWeight="medium">
                                        {moment(
                                            plan.auditMetadata.createdOn
                                        ).format('D MMM `YY, hh:mm a z')}
                                    </Text>
                                }
                            />
                        </TooltipItem>
                    </TooltipSection>
                </TooltipBody>
            </TooltipContent>
        );
    }
}

export default FpPlanDetailsTooltip;
